/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForGcpOauthProtocol extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForGcpOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForGcpOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForGcpOauthProtocol>): ServiceAccountEphemeralCredentialsForGcpOauthProtocol {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForGcpOauthProtocol(), model);
        ServiceAccountEphemeralCredentialsForGcpOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForGcpOauthProtocol>): ServiceAccountEphemeralCredentialsForGcpOauthProtocol {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForGcpOauthProtocol.newInstance(<ServiceAccountEphemeralCredentialsForGcpOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForGcpOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForGcpOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForGcpOauthProtocol): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForGcpOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Token
     */
    access_token: string;

}
